import React, { useEffect, useState, createContext, useContext } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isLoggedIn, isLoggedOut } from '../components/actions';
// import { format } from "date-fns";

const BlogContexts = createContext();
//two components one is a provider, second is a consumer

const BlogProvider = ({ children }) => {
  const [login, setLogin] = useState({
    email: '',
    password: '',
  });

  const dispatch = useDispatch();
  const blog = useSelector((state) => state.SingleBlog);
  const authenticated = useSelector((state) => state.Auth);
  const blogs = useSelector((state) => state.Messages.post);
  const loading = useSelector((state) => state.Messages.loading);
  const error = useSelector((state) => state.Messages.error);

  console.log(blog);
  const [currentUser, setCurrentUser] = useState('');

  const [register, setRegister] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
  });

  const getToken = () => {
    return sessionStorage.getItem('token') || null;
  };
  const getUser = () => {
    const user = sessionStorage.getItem('User');
    user && setCurrentUser(JSON.parse(user));
  };

  useEffect(() => {
    getToken() ? dispatch(isLoggedIn(true)) : dispatch(isLoggedOut(false));
  }, [dispatch]);

  useEffect(() => {
    getUser();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value });
  };

  const history = useHistory();

  const handleLogin = (e) => {
    e.preventDefault();
    // setConfirmFields('');
    const user = {
      email: login.email,
      password: login.password,
    };

    axios
      .post('https://authy.biduwe.com/auth/login', user)
      .then((res) => res.data)
      .then((data) => {
        setCurrentUser(data.data.user);
        dispatch(isLoggedIn(true));
        console.log(data.data.user);
        sessionStorage.setItem('token', JSON.stringify(data.data.token));
        sessionStorage.setItem('User', JSON.stringify(data.data.user));
        login.email = '';
        login.password = '';
        history.push('/');
      })
      .catch((error) => console.log(error));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setRegister({ ...register, [name]: value });
  };

  const Register = (e) => {
    e.preventDefault();
    // setConfirmFields('');
    const user = {
      email: register.email,
      password: register.password,
      firstName: register.firstName,
      lastName: register.lastName,
    };

    // console.log(user);
    axios
      .post('https://authy.biduwe.com/auth/register', user)
      .then((res) => res.data)
      .then((data) => {
        console.log(data.token);
        console.log(data);
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('User', JSON.stringify(data.data));
        setCurrentUser(data.data);
        dispatch(isLoggedIn(true));
        register.email = '';
        register.password = '';
        register.firstName = '';
        register.lastName = '';
        history.push('/');
      })
      .catch((error) => console.log(error));
  };

  const handleLogout = () => {
    // sessionStorage.setItem('token', '');
    // history.push('/');
    dispatch(isLoggedOut(false));
    sessionStorage.clear();
    setCurrentUser('');
  };

  const handleEditReply = () => {
    console.log('edited');
  };

  const handleDeleteReply = () => {
    console.log('deleted');
  };
  return (
    <BlogContexts.Provider
      value={{
        handleLogin,
        login,
        register,
        Register,
        handleChange2,
        handleChange,
        currentUser,
        blog,
        handleLogout,
        authenticated,
        handleEditReply,
        handleDeleteReply,
        blogs,
        loading,
        error,
      }}
    >
      {children}
    </BlogContexts.Provider>
  );
};

const useBlogContext = () => {
  return useContext(BlogContexts);
};

export { useBlogContext, BlogProvider };
